<script>
  import Icon from 'fa-svelte';
  import { icons } from '../helpers/IconsResolver';
</script>


<footer class="contacts">
  <a
  class="contacts__contact"
  target="_blank"
  href="https://www.linkedin.com/in/vhumeniuk/" >
    <Icon class="contacts__icon" icon={icons['Linkedin']} />
    <span>Linkedin</span>
  </a>

  <a
  class="contacts__contact"
  target="_blank"
  href="https://github.com/VladimirHumeniuk/" >
    <Icon class="contacts__icon" icon={icons['Github']} />
    <span>Github</span>
  </a>

  <a
  class="contacts__contact"
  href="mailto:v.humeniuk@outlook.com">
    <Icon class="contacts__icon" icon={icons['Envelope']} />
    <span>v.humeniuk@outlook.com</span>
  </a>

  <a
  class="contacts__contact"
  target="_blank"
  href="https://www.facebook.com/vhumeniuk91/">
    <Icon class="contacts__icon" icon={icons['Facebook']} />
    <span>Facebook</span>
  </a>

  <a
  class="contacts__contact"
  href="https://t.me/vhmnk">
    <Icon class="contacts__icon" icon={icons['Telegram']} />
    <span>Telegram</span>
  </a>
</footer>

<style lang="scss">
  @import '../styles/variables';

  .contacts {
    display: flex;
    justify-content: space-around;
    padding: 80px 15px;
    text-align: center;

    @media (max-width: $mq-sm) {
      padding: 40px 15px;
      flex-direction: column;
    }
  }

  .contacts__contact {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-decoration: none;
    color: var(--c-primary);
    margin-left: 5px;
    margin-right: 5px;
    font-family: 'Comfortaa';

    @media (max-width: $mq-sm) {
      & ~ & {
        margin-top: 25px;
      }
    }

    &:visited {
      color: var(--c-primary);
    }

    &:hover {
      color: var(--c-accent);
    }

    span {
      color: #333;
    }
  }

  :global(.contacts__icon) {
    font-size: 2.1em;
    margin-bottom: 24px;
  }
</style>